/* Pokémon Showcase spotlight controller.
   Both lanes flip on ONE shared timer (same pace, same beat): per lane, the
   card at the current index gets .is-center (sharp, highlighted), its
   neighbours get .is-left / .is-right (blurred, dimmed), everything else
   .is-out (hidden off the left edge). A card re-entering from hidden is
   teleported (transition suppressed) to the right slot so it never streaks
   across the stage.

   Manual browsing: swipe/drag a lane horizontally to step it back and forth,
   or tap/click a half-visible side card to bring it to the front (side-card
   clicks step instead of navigating; only the front card links out). Any
   manual step holds the shared auto-beat for a few seconds — both lanes stay
   on the same pace once it resumes. Hovering a lane also holds the beat.
   Reduced-motion keeps the flip but drops the animation (instant swaps). */
(function () {
  var HOLD_AFTER_MANUAL_MS = 6000;
  var SWIPE_MIN_PX = 40;

  function init() {
    var root = document.querySelector('.pkshow');
    if (!root) return;
    var stages = root.querySelectorAll('[data-pkshow-lane]');
    if (!stages.length) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('pkshow--reduced');
    }

    var holdUntil = 0;
    var lanes = [];
    Array.prototype.forEach.call(stages, function (stage) {
      var cards = stage.querySelectorAll('.pkshow__card');
      if (!cards.length) return;
      lanes.push({ stage: stage, cards: cards, i: 0 });
    });
    if (!lanes.length) return;

    function apply(lane) {
      var n = lane.cards.length;
      for (var k = 0; k < n; k++) {
        var card = lane.cards[k];
        var rel = (k - lane.i + n) % n;
        var slot = 'is-out';
        if (rel === 0) slot = 'is-center';
        else if (rel === 1 && n > 1) slot = 'is-right';
        else if (rel === n - 1 && n > 2) slot = 'is-left';
        if (card.dataset.slot === slot) continue;
        // hidden → visible: teleport into place so the card doesn't streak
        // across the stage behind the highlight
        if (card.dataset.slot === 'is-out') {
          card.classList.add('pkshow__card--teleport');
        }
        card.classList.remove('is-center', 'is-left', 'is-right', 'is-out');
        card.classList.add(slot);
        card.dataset.slot = slot;
        if (card.classList.contains('pkshow__card--teleport')) {
          void card.offsetWidth; /* apply position before re-enabling transitions */
          card.classList.remove('pkshow__card--teleport');
        }
      }
    }

    function step(lane, dir) {
      var n = lane.cards.length;
      if (n < 2) return;
      lane.i = (lane.i + dir + n) % n;
      apply(lane);
    }

    lanes.forEach(function (lane) {
      apply(lane);

      // swipe / drag to browse (vertical page scroll stays native via
      // touch-action: pan-y in CSS)
      var start = null;
      lane.suppressClick = false;
      lane.stage.addEventListener('pointerdown', function (e) {
        start = { x: e.clientX, y: e.clientY };
      });
      lane.stage.addEventListener('pointerup', function (e) {
        if (!start) return;
        var dx = e.clientX - start.x;
        var dy = e.clientY - start.y;
        start = null;
        if (Math.abs(dx) > SWIPE_MIN_PX && Math.abs(dx) > Math.abs(dy)) {
          step(lane, dx < 0 ? 1 : -1);
          holdUntil = Date.now() + HOLD_AFTER_MANUAL_MS;
          lane.suppressClick = true; /* the drag shouldn't count as a click */
          setTimeout(function () { lane.suppressClick = false; }, 350); /* only eat the click belonging to THIS gesture */
        }
      });

      // edge nav bars step the lane directly
      var col = lane.stage.parentElement;
      var prev = col.querySelector('.pkshow__nav--prev');
      var next = col.querySelector('.pkshow__nav--next');
      if (prev) prev.addEventListener('click', function () { step(lane, -1); holdUntil = Date.now() + HOLD_AFTER_MANUAL_MS; });
      if (next) next.addEventListener('click', function () { step(lane, 1); holdUntil = Date.now() + HOLD_AFTER_MANUAL_MS; });

      // tapping a blurred side card brings it to the front instead of
      // navigating; the front card stays a normal product link
      lane.stage.addEventListener('click', function (e) {
        if (lane.suppressClick) {
          lane.suppressClick = false;
          e.preventDefault();
          return;
        }
        var card = e.target.closest ? e.target.closest('.pkshow__card') : null;
        if (!card) return;
        if (card.classList.contains('is-right')) {
          e.preventDefault();
          step(lane, 1);
          holdUntil = Date.now() + HOLD_AFTER_MANUAL_MS;
        } else if (card.classList.contains('is-left')) {
          e.preventDefault();
          step(lane, -1);
          holdUntil = Date.now() + HOLD_AFTER_MANUAL_MS;
        }
      });
    });

    var stepMs = (parseFloat(root.dataset.step) || 4) * 1000;
    setInterval(function () {
      if (Date.now() < holdUntil) return;
      // hovering either lane holds the whole beat — the lanes stay in lockstep
      for (var i = 0; i < lanes.length; i++) {
        if (lanes[i].stage.matches(':hover')) return;
      }
      lanes.forEach(function (lane) {
        step(lane, 1);
      });
    }, stepMs);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
